import { useCallback, useEffect, useMemo, useRef, useState } from "react";

export function useResizeTools() {
  const videoW = 1920,
    videoH = 1080;
  const [w, setW] = useState<number>(videoH);
  const [h, setH] = useState<number>(videoH);
  const [paddingX, setPaddingX] = useState<number>(0);
  const [paddingY, setPaddingY] = useState<number>(videoH);

  const [scale, setScale] = useState<number>(1);

  useEffect(() => {
    setSize();
  });

  const setSize = () => {
    // 屏幕比视频矮,所以宽度要适配，高度要溢出
    const wh = window.innerHeight;
    const ww = window.innerWidth;
    if (ww / wh > videoW / videoH) {
      const w = ww;
      setW(w);
      const h = (videoH / videoW) * w;
      setH(h);
      setPaddingX(0);
      setPaddingY((h - wh) / 2);
      setScale(w / videoW);
    } else {
      const h = wh;
      setH(h);
      const w = (videoW / videoH) * h;
      setW(w);
      setPaddingX((w - ww) / 2);
      setPaddingY(0);
      setScale(h / videoH);
    }
    // console.log("-------------------", paddingX);
  };

  return { setSize, w, h, paddingX, paddingY ,scale };
}
